<div class="modal-header">
    <h1 class="modal-title">{{ modalTitle }}</h1>
</div>
<div class="modal-body">
    <ng-select *ngIf="dropdownItems"
               [items]="dropdownItems"
               id="dropdownMenu"
               style="width:200px"
               [(ngModel)]="selectedItem"
               [bindLabel] ="bindLabel"
               [disabled]="dropdownItems.length <= 1">
    </ng-select>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="saveAndCloseModal()">{{ confirmationButtonText }}</button>
    <button type="button" class="btn btn-default" (click)="closeModal()">{{ cancelButtonText }}</button>
</div>